import { g as getLanguageCode } from './get-language-code.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
* **GuestCentric**
*
* Official: www.guestcentric.com
*
* Example: <a href="http://www.dorisol.com/dorisol-buganvilia/hotel-overview.html" target="_blank">Dorisol Bungavilia</a>
*
* @exports bs_10
* @category engines
*/
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_10
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const pageCheckFunc = thn.debounce(thn.pageCheck, 500);
        // Guestcentric has their own promocode handling that is useful for us to apply the promocode.
        if (window.bgo && window.bgo.promotionalCodes) {
            thn.guestcentric_apply_promocode = function ({ code }) {
                window.bgo.promotionalCodes.init();
                window.bgo.promotionalCodes.startup();
                window.bgo.promotionalCodes.add(code);
            };
        }
        thn.observeDom(document.querySelector('body'), pageCheckFunc, {
            childList: false,
            subtree: false,
            attributes: true,
            attributeList: ['class'],
        });
        thn.shutdown(function () {
            thn.stopObserveDom(document.querySelector('body'), pageCheckFunc);
            delete thn.guestcentric_apply_promocode;
        });
    };
    /**
       * @memberOf module:bs_10
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let aux;
            const $ = window.jQuery;
            aux = window.location.pathname.match(ctx.urlRe);
            if (aux && ctx.langs.test(aux[1])) {
                resolve(aux[1]);
                return;
            }
            aux = (document.getElementsByTagName('body')[0].getAttribute('class') || '').split(/\s+/).filter(function (name) {
                return ctx.langs.test(name);
            }).reverse();
            if (aux.length) {
                resolve(aux[0]);
                return;
            }
            // PID: 1036946
            if (thn.data.propertyId === 1036946 && window.location.host.match(/youandthesea\.pt/)) {
                let language;
                if (window.location.hostname.includes('en')) {
                    language = 'en';
                }
                else {
                    language = 'pt';
                }
                if (language && ctx.langs.test(language)) {
                    resolve(language);
                    return;
                }
            }
            thn.domReady().then(function () {
                aux = document.getElementById('bgLanguageSelector');
                aux = aux && (aux.innerText || aux.textContent);
                aux = aux && getLanguageCode(aux);
                if (aux) {
                    resolve(aux);
                    return;
                }
                aux = thn.parseUrlParameter('apikey');
                if (aux && aux === '1978f92db75d9d9856bae7947f3621c3') {
                    resolve('es');
                    return;
                }
                if (aux && aux === '0d08c1fd08d282bd0b52a22b017418f0') {
                    resolve('en');
                    return;
                }
                aux = Array.from(document.getElementsByTagName('meta')).filter(function (meta) {
                    return meta.getAttribute('http-equiv') === 'content-language';
                });
                aux = aux && aux.length && aux[0].getAttribute('content');
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                // Property example - 1014245
                aux = $ && $('#divLangues').length;
                if (aux) {
                    aux = $('.linkLangue').text() || 'en';
                    resolve(aux);
                    return;
                }
                reject('no_language');
            });
        });
    };
    /**
       * @memberOf module:bs_10
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        ctx.promocode = document.querySelector('.promoCodesList li.selected')?.getAttribute('data-code')
            || document.querySelector('.pcodes-item')?.getAttribute('data-code');
        return ctx.promocode;
    };
    /**
       * @memberOf module:bs_10
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const element = document.querySelector('#bgResults');
        let observer;
        let loading;
        let results;
        let formerLanguage;
        const pidsForceMapping = [1034551, 1034551, 1027007, 1041384, 1034551, 1036949, 1011828];
        // Wait to Stage have been deployed
        if (element) {
            // Build Observe DOM function
            observer = thn.debounce(function () {
                // recheck lang
                formerLanguage = thn.data.language;
                thn.languageCheck().then(function () {
                    var bookingHeader;
                    if (thn.data.language === undefined) {
                        thn.data.language = formerLanguage;
                    }
                    // Price Monitor
                    if (pidsForceMapping.includes(thn.data.propertyId)) {
                        // We force the pageCheck to make the tools visible again,
                        // or other tools may appear if they use dates or guest as targeting.
                        thn.pageCheck({ force: true });
                        if (thn.data.pageName === 'Rooms and Rates') {
                            thn.widgets.price.refresh();
                        }
                    }
                    else {
                        ctx.widget.logger.debug('*************** DOM Changed **************');
                        ctx.widget.remove().setData();
                        if (ctx.widget.isSet()) {
                            if (document.getElementById('bgLoading_c').style.visibility === 'hidden'
                                && (document.getElementById('offerOptionsDialog_c') === null
                                    || document.getElementById('offerOptionsDialog_c').style.visibility === 'hidden')
                                && ((document.querySelectorAll('#bgCal .calcell.selected')
                                    && document.querySelectorAll('#bgCal .calcell.selected').length >= 2))) {
                                ctx.widget.show();
                            }
                        }
                    }
                    // Confirmed: 2 pages
                    // - 2: the real booking confirmed page with all the summary info
                    // - 1: the previous page with the extras/upgrades
                    bookingHeader = document.querySelector
                        && document.querySelector('.confirmHeader .code');
                    if (bookingHeader && thn.isVisible(bookingHeader)) {
                        thn.widgets.booking.init();
                    }
                    if (document.getElementById('bgeBookingSummary')) {
                        thn.widgets.booking.reset().init();
                        thn.stopObserveDom(element, observer);
                    }
                    // Check for User Register
                    if (document.getElementById('bgUserData_c')
                        && document.getElementById('bgUserData_c').style.visibility !== 'hidden') {
                        ctx.widget.remove(false);
                        thn.sendPageVisit('register');
                    }
                }); // language
            }, 400);
            thn.observeDom(element, observer);
            thn.pageUnload(function () {
                thn.stopObserveDom(element, observer);
            });
            // Mobile
        }
        else if (window.location.pathname === '/api/mobile/') {
            loading = document.querySelector && document.querySelector('.loadingData:not(.hide)');
            results = document.querySelector && document.querySelector('#resultsList');
            // IF
            // 1 - page is loading OR
            // 2 - results list is still empty (on 1st load) OR
            // 3 - results list is not empty but not visible
            //     (on 2nd load, coming from other "pages")
            // THEN observe
            if (loading || results.children.length === 0 || !thn.isVisible(results)) {
                // start observation on the loading div
                observer = thn.debounce(function thnGuestcentricMobileObserver() {
                    ctx.widget.logger.debug('*************** DOM Changed **************');
                    if (results.children.length && thn.isVisible(results)) {
                        thn.stopObserveDom(results, observer);
                        ctx.widget.update();
                    }
                }, 800);
                thn.observeDom(results, observer);
                thn.pageUnload(function () {
                    thn.stopObserveDom(results, observer);
                });
            }
        }
        else {
            setTimeout(ctx.widget.observeDom, 1000);
        }
    };
    /**
       * @memberOf module:bs_10
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // https://book.almalusahotels.com/api/bg/book.php?apikey=6fe5df96bcd660aab2e5c978bcff10bc&url=https%3A%2F%2Fwww.almalusahotels.com%2Fbaixachiado%2F&channelKey=58e5de4e971fc00be29aa10492813ad4&_ga=2.115964806.1699911936.1700062203-1852897292.1700062201
        const url = new URL(ctx.baseUrl);
        const validUrl = url.hostname.match(/book|secure|guestcentric/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        // Export into ctx.newUrl
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
       * Implements **noRooms**.
       *
       * @memberOf module:bs_10
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        let perNight = false;
        let cur;
        let prices;
        let i;
        let period;
        let pricesList;
        const noRooms = document.getElementById('noResults') && document.getElementById('noResults').parentElement.getElementsByClassName('show');
        if (window.location.pathname !== '/api/mobile/') {
            // Dates
            if (document.getElementById('checkin')) {
                widgetData.dateBegin = (document.getElementById('checkin').getAttribute('data-value') || '').replace(/-/g, '/');
                widgetData.dateEnd = (document.getElementById('checkout').getAttribute('data-value') || '').replace(/-/g, '/');
            }
            // Price
            widgetData.price = undefined;
            // on modern browsers
            if (document.querySelectorAll) {
                if (document.getElementsByClassName('bg_price').length > 0) {
                    prices = Array.from(document.querySelectorAll('.bg_price h2') || []).map(function (el) {
                        return thn.parseNumber(el.textContent);
                    });
                    if (prices.length) {
                        widgetData.price = Math.min(...prices);
                    }
                    period = document.getElementsByClassName('bg_price')[0].parentNode.getElementsByClassName('bg_selectroom');
                    if (period && period.length && !period[0].textContent.match(/\d+/)) { // when digit (per 2 nights) then price is per_stay
                        perNight = true;
                    }
                }
                // on legacy browsers
            }
            else {
                for (i = 0; i < document.getElementsByClassName('bg_price').length; i += 1) {
                    // this.logger.debug(thn.parse_sentence_for_number(document.getElementsByClassName('bg_price')[0].getElementsByTagName('p')[0].innerHTML.substr(document.getElementsByClassName('bg_price')[0].getElementsByTagName('p')[0].innerHTML.indexOf('</span>') + 7).trim()));
                    if ((typeof widgetData.price === 'undefined') || (document.getElementsByClassName('bg_price')[i].getElementsByTagName('p').length && widgetData.price > thn.parseNumber(document.getElementsByClassName('bg_price')[i].getElementsByTagName('p')[0].innerHTML.substr(document.getElementsByClassName('bg_price')[i].getElementsByTagName('p')[0].innerHTML.indexOf('</span>') + 7).trim()))) {
                        widgetData.price = thn.parseNumber(document.getElementsByClassName('bg_price')[i].getElementsByTagName('p')[0].innerHTML.substr(document.getElementsByClassName('bg_price')[0].getElementsByTagName('p')[0].innerHTML.indexOf('</span>') + 7).trim());
                    }
                }
            }
            // Currency
            cur = document.getElementsByClassName('"bg_currency"');
            if (!cur.length) {
                cur = document.getElementsByClassName('bg_currency');
            }
            if (cur.length) {
                widgetData.currency = thn.parseCurrency(cur[0].textContent);
            }
            // Currency legacy
            if (!widgetData.currency && document.getElementById('bgCurrencyInfo')) {
                if (document.getElementById('bgCurrencyInfo').innerHTML.indexOf('€') >= 0) {
                    widgetData.currency = 'EUR';
                }
                else if (document.getElementById('bgCurrencyInfo').innerHTML.indexOf('$') >= 0) {
                    widgetData.currency = 'USD';
                }
                else if (document.getElementById('bgCurrencyInfo').innerHTML.indexOf('£') >= 0) {
                    widgetData.currency = 'GBP';
                }
            }
            // Rooms
            widgetData.rooms = (document.getElementById('rooms') && parseInt(document.getElementById('rooms').value, 10)) || 1;
            widgetData.adults = (document.getElementById('adults') && parseInt(document.getElementById('adults').value, 10)) || 0;
            widgetData.children = (document.getElementById('children') && parseInt(document.getElementById('children').value, 10)) || 0;
            widgetData.guests = widgetData.adults + widgetData.children;
            // Assure everything is set
            if (widgetData.dateBegin && widgetData.dateEnd) {
                if (widgetData.price) {
                    if (!perNight) {
                        widgetData.price /= thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
                    }
                    widgetData.set = true;
                }
                else if (noRooms && noRooms.length) {
                    widgetData.noRooms = true;
                }
            }
            // mobile
        }
        else {
            const loading = document.querySelector && document.querySelector('.loadingData:not(.hide)');
            const results = document.querySelector && document.querySelector('#resultsList');
            // to set PW data page require:
            // 1 - page is not loading AND
            // 2 - results list is not empty AND
            // 3 - results list is visible
            if (!loading && results.children.length) {
                const getValueMobileGuestcentric = function (key) {
                    const dropdown = document.getElementById(key);
                    const defaultVal = key === 'rooms' || key === 'nights' ? 1 : (key === 'adults' ? 2 : 0);
                    let value = dropdown !== null ? (dropdown.options[dropdown.selectedIndex] || {}).value : defaultVal;
                    if (key !== 'checkin_month' && key !== 'checkin_day') {
                        value = parseInt(value, 10);
                    }
                    return value;
                };
                widgetData.rooms = getValueMobileGuestcentric('amount');
                widgetData.adults = getValueMobileGuestcentric('adults');
                widgetData.children = getValueMobileGuestcentric('children');
                widgetData.guests = widgetData.adults + widgetData.children;
                widgetData.dateBegin = `${(getValueMobileGuestcentric('checkin_month') || '').replace(/-/g, '/')}/${getValueMobileGuestcentric('checkin_day')}`;
                widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, getValueMobileGuestcentric('nights')));
                // IF ROOMS
                if (thn.isVisible(results)) {
                    prices = document.querySelectorAll('.total .ratePlaceholder .originalCurrencyValue');
                    pricesList = Array.from(prices);
                    widgetData.price = Number.MAX_VALUE;
                    pricesList.forEach(function (element) {
                        if ((typeof widgetData.price === 'undefined') || (widgetData.price > thn.parseNumber(element.getAttribute('value')))) {
                            widgetData.price = thn.parseNumber(element.getAttribute('value'));
                        }
                    });
                    // Currency
                    cur = document.getElementsByClassName('"bg_currency"');
                    if (!cur.length) {
                        cur = document.getElementsByClassName('bg_currency');
                    }
                    if (cur.length) {
                        widgetData.currency = thn.parseCurrency(cur[0].textContent);
                    }
                    if (widgetData.price === Number.MAX_VALUE) {
                        widgetData.price = undefined;
                    }
                    else {
                        widgetData.price /= thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
                        widgetData.set = true;
                    }
                    // NO ROOMS
                    if (document.getElementsByClassName('alert_overlay').length
                        && document.getElementsByClassName('alert_overlay')[0].parentElement.style.display === 'block') {
                        widgetData.noRooms = true;
                    }
                }
                else if (!thn.isVisible(results)
                    && document.querySelector('#alert')
                    && document.querySelector('#alert').style.display === 'block') {
                    widgetData.noRooms = true;
                }
            }
        }
        if (widgetData.noRooms !== true && document.querySelector('#bgShowAllOrSelBtn') && window.location.search.toLowerCase().includes('preselect')) {
            widgetData.priceSpecial = 1;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_10
       * @this thn.widgets.booking
       * @see {@link Booking#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        // Mobile
        if (window.location.pathname === '/api/mobile/') {
            const loading = document.querySelector && document.querySelector('.loadingData:not(.hide)');
            const confirmation = document.querySelector && document.querySelector('#confirmation');
            const pages = document.querySelector && document.querySelector('#pages');
            // if
            // 1 - page is loading OR
            // 2 - #confirmation is not in the page
            // then observe
            if (loading || !confirmation || !thn.isVisible(confirmation)) {
                // start observation
                const observer = thn.debounce(function thnGuestcentricMobileObserver() {
                    ctx.widget.logger.debug('*************** DOM Changed **************');
                    if (ctx.widget.setData().isSet()) {
                        thn.stopObserveDom(pages, observer);
                        ctx.widget.save();
                    }
                }, 1000);
                thn.observeDom(pages, observer);
                thn.pageUnload(function () {
                    thn.stopObserveDom(pages, observer);
                });
            }
        }
    };
    /**
       * Implements **bookingId**.
       *
       * @memberOf module:bs_10
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        let promocode;
        // Mobile
        if (window.location.pathname === '/api/mobile/') {
            const loading = document.querySelector && document.querySelector('.loadingData:not(.hide)');
            const confirmation = document.querySelector && document.querySelector('#confirmation');
            // force the booking as not set IF
            // 1 - page is loading OR
            // 2 - #confirmation is not in the page
            // 3 - #confirmation is not visible
            // 4 - the reservation failed
            if (loading || !confirmation || !thn.isVisible(confirmation) || document.getElementsByClassName('reservationOk').length === 0) {
                widgetData.set = false;
            }
            else {
                let price = document.getElementById('confirmationBookTotalAmount');
                price = price && price.textContent;
                if (price) {
                    widgetData.price = thn.parseNumber(price);
                    widgetData.currency = thn.getCurrencyCode(price.match(/[^\d\s,.]+/)[0]);
                }
                const conf = document.querySelector && document.querySelector('#confirmation h3'); // the first one
                const confMatch = conf && conf.textContent.trim().match(/:\s+(\d+)/);
                if (confMatch) {
                    widgetData.bookingId = confMatch[1];
                }
                let checkin = document.querySelector && document.querySelector('#confirmation .bookInfo h3 + ul li .value'); // the first one
                let nights = document.querySelector && document.querySelector('.nrNights');
                if (checkin && nights) {
                    checkin = checkin.textContent.trim();
                    nights = nights.textContent.trim();
                    if (checkin.match(/^[\d/]+$/) && nights.match(/^\d+$/)) {
                        nights = parseInt(nights, 10) || 1;
                        if (checkin.match(/\d{4}\/\d{2}\/\d{2}/)) { // format
                            widgetData.dateBegin = checkin;
                        }
                        else if (checkin.match(/\d{2}\/\d{2}\/\d{4}/) && parseInt(checkin.split('/')[1], 10) > 12) {
                            widgetData.dateBegin = checkin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
                        }
                        else {
                            widgetData.dateBegin = checkin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                        }
                        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, nights));
                    }
                }
                const promocodeEl = document.querySelector('.promoCodesList li.selected');
                if (promocodeEl) {
                    promocode = promocodeEl.getAttribute('data-code');
                }
            }
            // Desktop
        }
        else {
            try {
                const dateBegin = (document.querySelector('#bgCheckInValue') || {}).textContent;
                const dateEnd = (document.querySelector('#bgCheckOutValue') || {}).textContent;
                if (dateBegin.length && dateEnd.length) {
                    widgetData.dateBegin = translateDate(dateBegin, thn.data.language);
                    widgetData.dateEnd = translateDate(dateEnd, thn.data.language);
                }
                else {
                    const nightsParam = thn.parseUrlParameter('nrNights');
                    // startDay param may change format
                    // Example 1: https://book.galoresort.com/api/bg/book.php?apikey=2332da77b90cbcdff4e2afc4ccd3da20&startDay=08%2F28%2F2020&nrAdults=4&nrChildren=0&pc=&nrNights=2&l=en_US
                    // Example 2: https://book.galoresort.com/api/bg/book.php?nrNights=7&startDay=2020-08-23&room=room3&promotion=promo28&l=en&apikey=2332da77b90cbcdff4e2afc4ccd3da20&channelKey=58e5de4e971fc00be29aa10492813ad4
                    const startParam = thn.parseUrlParameter('startDay').trim();
                    if (startParam.match(/(\d{2})\/(\d{2})\/(\d{4})/)) {
                        // 08/28/2020 -> 2020/08/28
                        widgetData.dateBegin = startParam.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$1/$2');
                    }
                    else if (startParam.match(/(\d{4})\D+(\d{2})\D+(\d{2})/)) {
                        // 2020-08-23 -> 2020/08/23
                        widgetData.dateBegin = startParam.replace(/-/g, '/');
                    }
                    else {
                        // No examples of this legacy option
                        // apparently input should be "23-08-2020"
                        widgetData.dateBegin = startParam.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                    }
                    if (widgetData.dateBegin) {
                        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, nightsParam));
                    }
                    // If dates are not present in the URL, then just take the ones saved by the PW (as it's a SPA)
                    if (!widgetData.dateBegin || !widgetData.dateEnd) {
                        widgetData.dateBegin = thn.widgets.price.data.dateBegin;
                        widgetData.dateEnd = thn.widgets.price.data.dateEnd;
                    }
                }
            }
            catch (err) {
                widgetData.dateBegin = thn.widgets.price.data.dateBegin;
                widgetData.dateEnd = thn.widgets.price.data.dateEnd;
            }
            // Currency and price: option 1
            const totalEl = document.querySelector('#bgTotalFinalValue');
            if (totalEl) {
                widgetData.currency = thn.parseCurrency(totalEl.textContent);
                widgetData.price = thn.parseNumber(totalEl.textContent);
            }
            // Currency: option 2
            if (!widgetData.currency) {
                try {
                    const cur = document.getElementsByClassName('bg_total')[1].textContent.match(/[^\s\d.,]+/)[0];
                    widgetData.currency = thn.getCurrencyCode(cur);
                }
                catch (err) {
                    // Fallback
                    widgetData.currency = thn.widgets.price.data.currency;
                }
            }
            // Price: option 2
            if (!widgetData.price) {
                try {
                    widgetData.price = thn.parseNumber(document.getElementsByClassName('totalAmount')[0].textContent);
                }
                catch (err) {
                    // do this here, estimated data will not be right as this is SPA
                    if (widgetData.dateBegin && widgetData.dateEnd && thn.widgets.price.data.price) {
                        widgetData.price = thn.widgets.price.data.price * thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
                    }
                }
            }
            const codeEls = document.getElementsByClassName('code');
            if (codeEls.length) {
                widgetData.bookingId = codeEls[0].textContent.trim();
            }
            promocode = ((([...document.querySelectorAll('[id^="yui__dyn"][src*="bgEmailInput="]')].map((el) => thn.parseUrlParameter('pc', decodeURI(el.src))).filter((el) => el.length > 2) || [])[0] || '').match(/\["(.+)"\]/) || [])[1];
        }
        if (promocode) {
            widgetData.promocode = promocode;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
